<!-- <h2 mat-dialog-title>Help Information</h2> -->
<mat-dialog-content>
  <p><strong>Explaination: </strong>{{ data.description }}</p>
  <p><strong>Values-Types: </strong> {{ data.content }}</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end;">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>